export default __webpack_public_path__ + "media/color/exmo-c8b25a53.svg";